<template>
	<div class="student-index">
		<headerTemplate title="学生管理后台"></headerTemplate>
		<Board></Board>
		<van-cell title="学习任务" is-link :to="{name:'Task'}">
			<van-icon color="#606266" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="教学评估" is-link :to="{name:'Evaluation'}">
			<van-icon name="passed" color="#606266" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="理论考试" is-link :to="{name:'Theory'}">
			<van-icon name="records" color="#606266" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="规划书详情" is-link :to="{name:'PlanBook'}">
			<van-icon name="sign" color="#606266" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="成果展示" is-link :to="{name:'Achieve'}">
			<van-icon name="gift-card-o" color="#606266" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
	</div>
</template>

<script>
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	import Board from '@/components/sale/board/Board'
	export default {
		name: 'StudentIndex',
		components: {
			headerTemplate, Board
		},
		data() {
			return {}
		},
		methods: {}
	}
</script>

<style lang="scss" scoped>

</style>